export const SQLiteKeywords: string[] = ['AUTOINCREMENT'];
